function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "smartphone_rotation"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m4 8h2c.552 0 1-.448 1-1 0-.35-.19-.642-.462-.821.947-.895 2.111-1.553 3.397-1.893.534-.141.853-.688.712-1.222s-.684-.853-1.222-.712c-1.697.448-3.236 1.331-4.447 2.54-.056-.499-.464-.892-.978-.892-.552 0-1 .448-1 1v2c0 .552.448 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20 16h-2c-.552 0-1 .448-1 1 0 .35.19.642.462.821-.947.895-2.111 1.553-3.397 1.893-.534.141-.853.688-.712 1.222.118.449.523.746.966.746.084 0 .17-.011.255-.034 1.697-.447 3.236-1.33 4.447-2.539.057.498.465.891.979.891.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.192 7.051-4.243-4.243c-1.13-1.13-3.112-1.13-4.242 0l-9.899 9.899c-1.17 1.169-1.17 3.073 0 4.242l4.243 4.243c.565.565 1.318.876 2.121.876s1.556-.311 2.121-.876l9.899-9.899c1.17-1.169 1.17-3.073 0-4.242zm-1.414 2.828-9.899 9.899c-.374.374-1.04.374-1.414 0l-4.243-4.243c-.39-.39-.39-1.024 0-1.414l9.899-9.899c.187-.187.438-.29.707-.29s.52.103.707.29l4.243 4.243c.39.389.39 1.024 0 1.414z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 16,
  r: 1
})));

var Svg107Smartphone = function Svg107Smartphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg107Smartphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/107-smartphone.7a0a6d3f.svg";
export { ForwardRef as ReactComponent };